export default "__VITE_ASSET__aL1TSgbr__"